import React from 'react';
import HeroBookDemoCta from './HeroBookDemoCta';
import HeroBrandLogo from './HeroBrandLogo';
import HeroTypewriterTitle from './HeroTypewriterTitle';
import '../hero/HeroSection.css';
import './ContactHeroSection.css';

const ContactHeroSection: React.FC = () => (
  <section className="hero">
    <div className="hero-bg" aria-hidden="true">
      <img src="/images/hero_lummo.png" alt="" loading="eager" className="hero-bg-img" />
      <div className="hero-vignette" />
    </div>
    <div className="hero-container">
      <div className="hero-inner">
        <HeroTypewriterTitle text="Join the Future of Clinical Trials" />
        <p className="hero-subtitle">Tell us about your organization and we will prepare a personalized walkthrough of Lummo for your team.</p>
        <HeroBookDemoCta />
        <HeroBrandLogo />
      </div>
    </div>
    <div className="scroll-indicator" aria-hidden="true">
      <span className="scroll-dot" />
    </div>
  </section>
);
export default ContactHeroSection;
